import React, { useEffect, useState, useRef } from "react";
import { Card, ListGroup, Form, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import RowTitles from "../components/RowTitles";
import axios from "axios";
import Loader from "../gif/loader.gif";
import { FaChevronRight } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { LiaSmsSolid } from "react-icons/lia";

const Chat = () => {
  const navigate = useNavigate();
  //
  const [activeContact, setActiveContact] = useState(null);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [data, setData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const blurTimeoutRef = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const suggestions = data.filter((item) =>
    item.name.toLowerCase().includes(keyword.toLowerCase())
  );
  //const suggestions = contacts;

  const handleContactClick = async (contact) => {
    setShowSuggestions(false);
    setActiveContact(contact);
    getMessages(contact.cell);
  };
  const handleBlur = () => {
    // Use a timeout to allow click events to process first
    blurTimeoutRef.current = setTimeout(() => {
      setShowSuggestions(false);
    }, 200);
  };
  function handleFocus() {
    setShowSuggestions(true);
  }

  const handleSendMessage = async () => {
    //
    try {
      const res = await axios.post(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/save-message`,
        {
          names: activeContact.name,
          email: activeContact.cell,
          message,
          status: "sent",
        }
      );
      let retcode = res.data.message;
      if (retcode === "Message saved") {
        getMessages(activeContact.cell);
        getContacts();
      }
      console.log(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("post error =>" + error);
    }

    setMessage("");
  };
  //
  const getMessages = async (cell) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-messagebyemail?email=${cell}`,
        {
          validateStatus: function (status) {
            // Accept both 200 and 404 status codes as valid responses
            return (status >= 200 && status < 300) || status === 404;
          },
        }
      );
      let retcode = res.data;
      console.log(res.status);
      if (!(res.status === 404 && res.data.message === "No records found")) {
        console.log(retcode);
        setMessages(retcode);
      }
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get messages error =>" + error);
    }
  };
  //
  const getMembers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-members`
      );
      let retcode = res.data;
      setData(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get members error =>" + error);
    }
  };
  const getContacts = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-previews`
      );
      let retcode = res.data;
      //delare empty array
      setContacts(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get all contacts =>" + error);
    }
  };
  const handleChange = (e) => {
    setKeyword(e.target.value);
  };
  useEffect(() => {
    getMembers();
    getContacts();
  }, []);

  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />
        <div className="container-fluid mt-4 ml-2 mr-2">
          <div className="row">
            <div className="row">
              <div className="col-md-4 p-3">
                <RowTitles title={"Dashboad"} child={"Send sms message"} />
              </div>
              <div className="col-md-8 p-3 text-end">
                <button
                  className="btn  text-white me-2 mt-2 mb-3"
                  style={{ borderRadius: 0, backgroundColor: "#3bc0c3" }}
                  onClick={() => navigate("/bulksms")}
                >
                  <LiaSmsSolid className="me-2" />
                  Bulk Sms's
                </button>
              </div>
            </div>

            {/* Contacts Sidebar */}
            <div className="col-md-4 p-3">
              <Card
                className="rounded"
                style={{
                  height: "90vh",
                }}
              >
                <Card.Header className="border-bottom">
                  <Form.Group className="flex-grow-1">
                    <div className="d-flex align-items-center">
                      <Button
                        variant="primary"
                        className="rounded-0 me-0 text-sm"
                        style={{
                          fontSize: 14,
                          backgroundColor: "#33afe0",
                          borderColor: "#33afe0",
                        }}
                        onClick={handleFocus}
                      >
                        New Message
                      </Button>
                      <input
                        type="search"
                        placeholder="Search member name..."
                        className="border-0 rounded-0 ms-0 p-2"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                      />
                    </div>
                  </Form.Group>{" "}
                  {showSuggestions ? (
                    <ListGroup
                      className="position-absolute w-100 h-100 mt-1 shadow"
                      style={{
                        zIndex: 1000,
                        maxHeight: "350px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {suggestions.map((item) => (
                        <ListGroup.Item
                          key={item.id}
                          action
                          onClick={() => handleContactClick(item)}
                          className="border-0"
                          style={{ zIndex: 1 }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <strong>
                                {item.name},{item.surname}
                              </strong>
                              <p>
                                <small>MNo.: {item.mnumber}</small> |{" "}
                                <small>Number: {item.cell}</small>
                              </p>
                            </div>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  ) : null}
                </Card.Header>
                <small className="m-2">Messages history</small>
                <Card.Body className="p-0 overflow-auto">
                  <ListGroup variant="flush">
                    {loading ? (
                      <img
                        src={Loader}
                        alt="QR Code"
                        width={"50"}
                        height={"50"}
                        style={{ alignSelf: "center" }}
                      />
                    ) : (
                      //show contacts
                      contacts.map((contact) => (
                        <ListGroup.Item
                          key={contact.id}
                          action
                          active={activeContact?.id === contact.id}
                          onClick={() => handleContactClick(contact)}
                          className="border-0"
                        >
                          <div
                            className="d-flex align-items-center justify-content-between p-2"
                            style={{ border: "none" }}
                          >
                            <div className="d-flex align-items-center">
                              <div className="position-relative">
                                <div
                                  className="rounded-circle d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "48px",
                                    height: "48px",
                                    backgroundColor: "#eef1f6",
                                    fontWeight: "bold",
                                    color: "#33afe0",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {contact.name.slice(0, 2)}
                                </div>
                                <div
                                  className="position-absolute bottom-0 end-0 bg-success rounded-circle"
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    border: "2px solid white",
                                  }}
                                />
                              </div>
                              <div className="ms-3">
                                <h6 className="mb-0">{contact.name}</h6>
                                <small className="text-muted">
                                  {contact.message}
                                </small>
                              </div>
                            </div>
                            <div
                              className="d-flex align-items-center justify-content-center p-2"
                              style={{ width: "40px", height: "40px" }}
                            >
                              <FaChevronRight size={20} />
                            </div>
                          </div>
                        </ListGroup.Item>
                      ))
                    )}
                  </ListGroup>
                </Card.Body>
                <Card.Footer className="bg-white border-top"></Card.Footer>
              </Card>
            </div>

            {/* Chat Panel */}
            <div className="col-md-8 p-3 d-flex flex-column">
              {activeContact ? (
                <Card
                  className="rounded"
                  style={{
                    height: "90vh",
                  }}
                >
                  <Card.Header className="bg-white border-bottom">
                    <h5 className="mb-0">
                      {activeContact.names || activeContact.name}
                    </h5>
                    <small className="text-muted">
                      Last message: {activeContact.date}
                    </small>
                  </Card.Header>
                  <Card.Body className="flex-grow-1 overflow-auto">
                    {messages &&
                      messages.map((msg, index) => (
                        <div
                          key={index}
                          className={`mb-3 d-flex ${
                            msg.status != "sent"
                              ? "justify-content-end"
                              : "justify-content-start"
                          }`}
                        >
                          <div
                            className={`p-3 rounded ${
                              msg.status != "sent"
                                ? "bg-primary text-white"
                                : "bg-light"
                            }`}
                            style={{ maxWidth: "70%" }}
                          >
                            {msg.message}
                            <div
                              className={`small ${
                                msg.sender === "me"
                                  ? "text-white-50"
                                  : "text-muted"
                              } text-end`}
                            >
                              {new Date(msg.date).toLocaleTimeString()}
                            </div>
                          </div>
                        </div>
                      ))}
                  </Card.Body>
                  <Card.Footer className="bg-white border-top">
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Type a message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyPress={(e) =>
                          e.key === "Enter" &&
                          !e.shiftKey &&
                          handleSendMessage()
                        }
                      />
                      <Button variant="primary" onClick={handleSendMessage}>
                        Send
                      </Button>
                    </InputGroup>
                  </Card.Footer>
                </Card>
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <div className="text-center text-muted">
                    <h4>Select a contact to start messaging</h4>
                    <p>Click on NEW Message to start messaging members</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
